import { Box, Typography, Link, styled, useMediaQuery, useTheme } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { ROUTE_PRIVACY_POLICY, ROUTE_TERMS_AND_CONDITIONS } from "../../constants/routes";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import TwitterIcon from "@mui/icons-material/Twitter";

const LeftSection = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const CharacterImage = styled("img")({
    position: "absolute",
    right: isMobile ? "18%" : "20px",
    bottom: "0",
    height: isMobile ? "200px" : "150px",
    objectFit: "contain",
  });

  const SocialIconsContainer = styled(Box)({
    display: "flex",
    gap: "15px",
    marginTop: "10px",
    justifyContent: "center",
  });

  return (
    <Box
      sx={{
        backgroundColor: "#1A1A35",
        color: "#FFFFFF",
        padding: "20px 20px",
        display: "flex",
        justifyContent: isMobile ? "center" : "space-between",
        alignItems: "flex-start",
        position: "relative",
        height: isMobile ? "400px" : "",
        textAlign: isMobile ? "center" : "",
      }}
    >
      <LeftSection>
        <Typography style={{ fontSize: isMobile ? "20px" : "16px", fontWeight: "400", marginBottom: "50px" }}>
          Have a question? <br />
          Reach out at{" "}
          <Link href="mailto:queries@seevi.in" style={{ color: "#FF7A00", textDecoration: "none" }}>
            queries@seevi.in
          </Link>
        </Typography>
        <SocialIconsContainer>
          <Link href="#" color="inherit" aria-label="Facebook">
            <FacebookIcon style={{ fontSize: 30 }} />
          </Link>
          <Link href="#" color="inherit" aria-label="Twitter">
            <TwitterIcon style={{ fontSize: 30 }} />
          </Link>
          <Link href="#" color="inherit" aria-label="LinkedIn">
            <LinkedInIcon style={{ fontSize: 30 }} />
          </Link>
          <Link href="#" color="inherit" aria-label="Instagram">
            <InstagramIcon style={{ fontSize: 30 }} />
          </Link>
          <Link href="#" color="inherit" aria-label="YouTube">
            <YouTubeIcon style={{ fontSize: 30 }} />
          </Link>
        </SocialIconsContainer>
        <Box
          sx={{
            display: "flex",
            gap: "20px",
            marginTop: isMobile ? "50px" : "10px",
            textAlign: isMobile ? "center" : "",
            justifyContent: "center",
          }}
        >
          <Link component={RouterLink} to={ROUTE_PRIVACY_POLICY} style={{ fontSize: "16px" }} color="inherit" underline="hover">
            Privacy policy
          </Link>
          <Link component={RouterLink} to={ROUTE_TERMS_AND_CONDITIONS} style={{ fontSize: "16px" }} color="inherit" underline="hover">
            Terms of use
          </Link>
        </Box>
      </LeftSection>
      <CharacterImage src="/images/Landing-page/footer-girl.png" alt="Character Illustration" />
    </Box>
  );
};

export default Footer;
